export default __webpack_public_path__ + "img/9527ba465972a4ab4c2a107b1b353105.png";